import {
  Component,
  DestroyRef,
  OnInit,
  output,
  forwardRef,
  ChangeDetectionStrategy,
  inject,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CreateCampaignLogicService } from '../../../services/create-campaign-logic.service';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Label } from 'src/app/models';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'app-group-labels',
    templateUrl: './group-labels.component.html',
    styleUrls: ['./group-labels.component.scss'],
    imports: [
        MatListModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatTooltipModule,
        MatCheckboxModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => GroupLabelsComponent),
            multi: true,
        },
    ]
})
export class GroupLabelsComponent implements OnInit {
  selectionChanged = output<Label[]>();

  isLoading = signal(false);
  labels = signal<Label[]>([]);
  noLabels = signal(false);
  public selectedNames = new Set<string>();

  private createCampaignService = inject(CreateCampaignLogicService);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.isLoading.set(true);

    this.createCampaignService.getLabels().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (data: Label[]) => {
        this.labels.set(data);
        this.noLabels.set(data.length === 0);
        this.isLoading.set(false);
      },
      error: (err) => {
        console.error('Observable emitted an error:', err);
        this.noLabels.set(true);
        this.isLoading.set(false);
      },
    });
  }

  onCheckboxChange(event: any, label: Label) {
    if (event.checked) {
      this.selectedNames.add(label.name);
    } else {
      this.selectedNames.delete(label.name);
    }

    // emit selected Label objects (filter original list)
    const selectedLabels = this.labels().filter(l =>
      this.selectedNames.has(l.name)
    );
    this.selectionChanged.emit(selectedLabels);
  }
}
